import { useParams, Link } from "react-router-dom";
import { cameraCategoryData } from "./Data/CameraCategoryData";

function ProductPage() {
  const { category, id } = useParams();

  const product = cameraCategoryData[category]?.find(
    (item) => item.id === Number(id)
  );

  if (!product) {
    return (
      <div className="p-10 text-center">
        <h2 className="text-2xl font-bold text-red-600">
          Product Not Found
        </h2>
        <Link to="/" className="text-blue-600 underline">
          Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">

      {/* Breadcrumb */}
      <div className="text-sm text-gray-500">
        <Link to="/" className="hover:text-black">Home</Link> / {category} / {product.title}
      </div>

      <div className="grid md:grid-cols-2 gap-10 mt-8">

        {/* Image */}
        <img
          src={product.img}
          alt={product.title}
          className="w-full h-[400px] object-cover rounded-xl shadow-lg"
        />

        {/* Product Details */}
        <div>
          <h1 className="text-3xl font-bold">{product.title}</h1>

          <p className="mt-4 text-gray-600">
            {product.description}
          </p>

          {/* Features */}
          <div className="mt-6">
            <h3 className="text-xl font-semibold mb-3">
              Key Features
            </h3>
            <ul className="space-y-2">
              {product.features.map((feature, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2 text-gray-700"
                >
                  ✔ {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="mt-8 flex gap-4">
            <button className="bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition">
              Request Quote
            </button>

            <button className="border border-black px-6 py-3 rounded-lg hover:bg-black hover:text-white transition">
              Call Now
            </button>
          </div>
        </div>
      </div>

      {/* Specifications Section */}
      <div className="mt-16">
        <h2 className="text-2xl font-bold mb-6">
          Technical Specifications
        </h2>

        <div className="grid md:grid-cols-2 gap-6 bg-gray-50 p-6 rounded-xl">
          {Object.entries(product.specifications).map(([key, value]) => (
            <div key={key} className="flex justify-between border-b pb-2">
              <span className="capitalize font-medium">{key}</span>
              <span className="text-gray-600">{value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Installation Section */}
      <div className="mt-16 bg-black text-white p-10 rounded-xl text-center">
        <h2 className="text-2xl font-bold">
          Professional Installation Available
        </h2>
        <p className="mt-4 text-gray-300">
          Our certified technicians provide complete CCTV setup
          across residential, commercial, and industrial locations.
        </p>

        <button className="mt-6 bg-white text-black px-6 py-3 rounded-lg font-semibold">
          Book Installation
        </button>
      </div>

    </div>
  );
}

export default ProductPage;